import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UserService } from '../_service/user.service';
import { LocationService } from '../_service/location.service';

@Component({
  selector: 'app-auth-levels',
  templateUrl: './auth-levels.component.html',
  styleUrls: ['./auth-levels.component.css']
})
export class AuthLevelsComponent implements OnInit {

  authorities;
  @Input() selectedAuthority;
  @Output() selectedAuthorityChange = new EventEmitter();
  newSiteName;
  
  level1Authorities;
  @Input() selectedLevel1Authority;
  @Output() selectedLevel1AuthorityChange = new EventEmitter();

  
  level2Authorities;
  @Input() selectedLevel2Authority;
  @Output() selectedLevel2AuthorityChange = new EventEmitter();

  authorityInput = { 
    rootAuthorityUnitId: null,
    parentAuthorityUnitId: null,
    name: ''
  };
  constructor(
    private userService: UserService,
    private locationService: LocationService,
  ) { }

  @Input() topLevel: string;
  ngOnInit() {}

  getAuthorityNames() {
    return this.userService.getAllTopAuthorities().subscribe(res => {
      this.authorities = res;
    });
  }

    getLevel1DropDown() {
    return this.userService.levelDropDown(this.selectedAuthority).subscribe(res => {
      this.level1Authorities = res;
    });
  }

  getLevel2DropDown() {
    return this.userService.levelDropDown(this.selectedLevel1Authority).subscribe(res => {
      this.level2Authorities = res;
    });
  }

  onUserSelectTop() {
    this.selectedAuthorityChange.emit(this.selectedAuthority);
    this.getLevel1DropDown();
  }
  onUserSelectLevel1(event) {
    this.selectedLevel1AuthorityChange.emit(this.selectedLevel1Authority);
    this.getLevel2DropDown();
  }

  onUserSelectLevel2(event) {
    this.selectedLevel2AuthorityChange.emit(this.selectedLevel2Authority);
  }
}
